import { Loader, Square } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const StopButton = ({
  buttonClassName,
  toggle,
  isLoading,
  disabled,
}: {
  toggle: () => void;
  buttonClassName?: string;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  return (
    <Button
      variant="destructive"
      size="icon"
      className={cn('h-10 w-10 rounded-full', buttonClassName)}
      onClick={toggle}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <Loader className="h-5 w-5 animate-spin" />
      ) : (
        <Square fill="currentColor" className="h-5 w-5" />
      )}
    </Button>
  );
};
